module.exports = __webpack_public_path__ + "img/wxgj.81879451.png";